import { render, staticRenderFns } from "./Linkedinlcon.vue?vue&type=template&id=96d10a00&"
import script from "./Linkedinlcon.vue?vue&type=script&lang=js&"
export * from "./Linkedinlcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports